import { Injectable, Inject} from '@angular/core';

 export abstract class BaseDO {

	private parentObject:BaseDO;
	
	public  versionId:Number;
	
	public  guid:String;
	
	public createdDt:Date;
	
	public updatedDt:Date;
	
	public  createdUser:String;
	
	public  updatedUser:String;

	
	// public abstract getObjectName();
	
}
